var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "testimonials-slider" }, [
    _c(
      "div",
      { staticClass: "slider-wrapper testimonials-slider__swiper" },
      [
        _c(
          "swiper",
          { ref: "slider", attrs: { options: _vm.swiperOptions } },
          [
            _vm._l(_vm.sliderData, function (slide, index) {
              return _c("swiper-slide", { key: index }, [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "testimonials-slider__slide" }, [
                    _c(
                      "blockquote",
                      { staticClass: "testimonials-slider__slide__quote" },
                      [
                        _c("p", {
                          domProps: { innerHTML: _vm._s(slide.quote) },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticClass: "testimonials-slider__slide__credit" },
                      [_vm._v(_vm._s(slide.credit))]
                    ),
                  ]),
                ]),
              ])
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "swiper-pagination",
              attrs: { slot: "pagination" },
              slot: "pagination",
            }),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/Testimonials.vue